export default __webpack_public_path__ + "static/media/clinical_notes.c3e5bf70.svg";